export default {
  api: {
    "sign-up": {
      "04000": "認証コードが不正です。",
      "04001": "アクセス元のブラウザが異なります。",
      "04002": "ワンタイムパスが有効期限切れです。",
      "04003": "最大試行回数をオーバーしました。",
      "02002": "すでにメールアドレスが利用されています。",
    },
    "rest-password": {
      "04000": "認証コードが不正です。",
      "04001": "アクセス元のブラウザが異なります。",
      "04002": "ワンタイムパスが有効期限切れです。",
      "04003": "最大試行回数をオーバーしました。",
      "02003": "アカウントが存在しません。",
      "02004": "パスワードの書式が不正です。",
    },
    "monitoring-devices": {
      "08000": "監視デバイス情報のアクセスに失敗しました。",
      "08001": "監視デバイスが見つかりませんでした。",
    },
    "monitoring-settings": {
      "09000": "監視対象に監視デバイスが紐付けできませんした。",
      "09001": "監視デバイスはすでに別の監視対象に利用されています。",
    },
    "contact-monitoring-event-rules": {
      19000: "監視イベントルールのAPIコールに失敗しました。",
      10010: "接点監視イベントルールのAPIコールに失敗しました。",
      10011: "接点監視はすでに設定すみです。",
    },
    subscriptions: {
      11000: "サブスクリプジョンのAPIコールに失敗しました。",
      11001: "サブスクリプションは登録済です。",
      11002: "支払いサイクルが不正です。",
      11003: "サブスクリプションが見つかりません。",
      // as-cmu
      11010: "AS-CMUサブスクリプションのAPIコールに失敗しました。",
      11011: "AS-CMUサブスクリプションが見つかりません。",
    },
    server: {
      99999: "サーバーエラーが発生しました",
    },
  },
};
